<template>
  <!-- advisory 中税咨询-->
  <div id="advisory">
    <herder-img :imgs="imgs"></herder-img>
    <!-- 内容 -->
    <div class="advisory-state">
      <div class="toggle-cont">
        <ul class="cont-in">
          <li @click="fontColor(1)" :class="type === 1 ? 'font-color': ''">政策法规</li>
          <li @click="fontColor(2)" :class="type === 2 ? 'font-color': ''">中税动态</li>
          <li @click="fontColor(3)" :class="type === 3 ? 'font-color': ''">热点问答</li>
        </ul>
      </div>
      <div class="request-cont" v-if="contList.length">
        <div class="request-item" v-for="item of contList" :key="item.createTime" @click="onMessage(item.id)">
          <div class="item-img">
            <img :src="'http://zhongshui.365hy.com/' + item.img" alt />
          </div>
          <div class="item-tim">
            <img src="./images/时间.png" alt />
            <span>{{item.createTime | timeFun}}</span>
          </div>
          <h4 class="item-h4">{{item.title}}</h4>
          <div class="item-txt">
            <p class="item-txt-p">{{item.describe}}</p>
          </div>
        </div>
      </div>
      <div class="request-no-data" v-else>
        暂无数据～～
      </div>
      <cpaginate
        v-if="contList.length"
        :pageCount="pageCount"
        :marginPages="marginPages"
        :rangePage="rangePage"
        :initPage="initPage"
        @pageEvent="pageEvent"
      ></cpaginate>
      <!-- <router-view></router-view> -->
    </div>
  </div>
</template>

<script>
import HerderImg from "@/common/herder-img";
import cpaginate from "@/common/pageination";
import request from "@/network/request.js";
// import axios from "axios";

export default {
  name: "advisory",
  data() {
    return {
      imgs: require("./images/组 2896.png"),
      type: 1,
      contList: [],
      pageCount: 10,
      marginPages: 2,
      rangePage: 5,
      initPage: 0
    };
  },
  components: {
    HerderImg,
    cpaginate
  },
  created() {
    this.requests(1);
  },
  filters: {
    timeFun: function(value) {
      let date = new Date(value);
      let str =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return str;
    }
  },
  methods: {
    fontColor(num) {
      console.log(num);
      switch (num) {
        case 1:
          this.type = 1;
          this.requests(1);
          break;
        case 2:
          this.type = 2;
          this.requests(1);
          break;
        case 3:
          this.type = 3;
          this.requests(1);
          break;
      }
    },
    pageEvent: function(e) {
      console.log(e);
      this.requests(e);
    },
    // 数据请求
    requests(page) {
      request({
        url: "/zhongshui/information/list",
        method: "post",
        params: {
          page: page,
          limit: 6,
          type: this.type
        }
      })
        .then(res => {
          console.log(res);
          let data = res.data;
          let count = data.count; // 请求到的数据量
          this.pageCount = Math.ceil(count / 6);
          console.log(data);
          this.contList = data.data;
        })
        .catch(err => {
          console.log("请求错误");
        });
    },
    // 跳转到详情
    onMessage(msg) {
      // console.log(msg)
      this.$router.push({'path': '/MESAGE', query: { id: msg }})
    }
  }
};
</script>

<style lang="scss" scoped>
.advisory-state {
  // width: 100%;
  // padding: 0 10%;
  width: 1040px;
  margin: 0 auto;
  box-sizing: border-box;
  .toggle-cont {
    .cont-in {
      display: flex;
      padding: 40px 0;
      li {
        list-style: none;
        font-size: 15px;
        margin-right: 15px;
        color: black;
      }
      li:hover {
        cursor: pointer;
      }
      .font-color {
        color: rgb(3, 98, 187);
        font-weight: 700;
      }
    }
  }
  .request-cont {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    .request-item {
      width: 31%;
      margin-right: 2%;
      margin-bottom: 2%;
      .item-img {
        width: 100%;
        height: 200px;
        overflow: hidden;
        img {
          width: 90%;
          height: 90%;
          display: block;
          margin: 0 auto;
        }
      }
      .item-tim {
        display: flex;
        align-items: center;
        height: 30px;
        img {
          width: 12px;
          margin-right: 5px;
        }
      }
      .item-h4 {
        margin-bottom: 12px;
        font-size: 13px;
      }
      .item-txt {
        height: 50px;
        width: 100%;
        .item-txt-p {
          color: rgb(128, 126, 126);
          line-clamp: 3;
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          display: -webkit-box;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
  .request-no-data {
    height: 200px;
    font-size: 20px;
    text-align: center;
    line-height: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/advisory/advisory.vue